import { render, staticRenderFns } from "./AjaxTable.vue?vue&type=template&id=0d730b0d"
import script from "./AjaxTable.vue?vue&type=script&lang=js"
export * from "./AjaxTable.vue?vue&type=script&lang=js"
import style0 from "./AjaxTable.vue?vue&type=style&index=0&id=0d730b0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports